interface popSettings {
	maxH: number
	minH: number
	step: number
	offsetTop: number
	offsetBottom: number
	offsetLeft: number
	width: number | 'parent'
	align?: 'center' | 'left' | 'right'
	autoChangePos?: boolean
}

export function usePopoverPosition(target: HTMLElement, link: HTMLElement, settings: popSettings) {
	const linkPos = link.getBoundingClientRect()
	const isMaxBottom = window.innerHeight > linkPos.top + settings.offsetTop + settings.maxH
	const isMinBottom = window.innerHeight > linkPos.top + settings.offsetTop + settings.minH
	let maxHeight = 0
	let left = 0
	let width = 0
	let isOver = false
	if (isMaxBottom) {
		maxHeight = settings.maxH
	} else if (isMinBottom) {
		const overHeight = window.innerHeight - (linkPos.top + settings.offsetTop + settings.minH)
		maxHeight = settings.minH + Math.floor(overHeight / settings.step) * settings.step
	} else {
		isOver = true
		maxHeight = settings.minH
		const isMaxTop = linkPos.top - settings.maxH - settings.offsetBottom > 0
		const isMinTop = linkPos.top - settings.minH - settings.offsetBottom > 0
		if (isMaxTop) {
			maxHeight = settings.maxH
		} else if (isMinTop) {
			const overHeight = linkPos.top - settings.minH - settings.offsetBottom
			maxHeight = settings.minH + Math.floor(overHeight / settings.step) * settings.step
		} else {
			isOver = false
			maxHeight = settings.minH
		}
	}
	if (settings.width === 'parent') {
		width = linkPos.width
	} else {
		width = settings.width
	}
	if (settings.width === 'parent') {
		left = linkPos.left
	} else if (settings.align) {
		if (settings.align === 'left') {
			left = linkPos.left
		} else if (settings.align === 'right') {
			left = linkPos.left + linkPos.width - width
		} else {
			left = linkPos.left + linkPos.width / 2 - width / 2
		}
	}
	if (settings.autoChangePos && isOver) {
		const bottom = window.innerHeight - linkPos.top + settings.offsetBottom
		target.style.maxHeight = rem(maxHeight)
		target.style.width = rem(width)
		target.style.bottom = rem(bottom)
		target.style.left = rem(left)
	} else {
		const top = linkPos.top + settings.offsetTop
		target.style.maxHeight = rem(maxHeight)
		target.style.width = rem(width)
		target.style.top = rem(top)
		target.style.left = rem(left)
	}
}

function rem(px: number) {
  return `${px}px`
}
